import React from 'react';
import Contact from '../components/sections/Contact';
import PageHeader from '../components/ui/PageHeader';
import './StaticPage.css';

const ContactPage: React.FC = () => (
  <div className="static-page">
    <PageHeader page="contact" />
    <Contact />
  </div>
);

export default ContactPage;
